import React, { useEffect } from 'react'
import './About.css'
import profilePic2 from '../../assets/profilePic3.png'
import { useStateValue } from '../../StateProvider';
import {useTranslation} from "react-i18next";
import CVfrench from '../../assets/CV_Berarma_Oussama.pdf'
import CVenglish from '../../assets/CV__Berarma_Oussama.pdf'


function About() {
    const AboutContainer = React.createRef();
    const [state, dispatch] = useStateValue();
    useEffect(() => {
        dispatch({
            type : "ADD_REF",
            ref : AboutContainer.current.offsetTop
        })
    }, [])
    const {t, i18n} = useTranslation('common');
    return (
        <div ref={AboutContainer}className="about">
            <img className="about__img"  src={profilePic2} alt=""/>
            <div className="about__desc">
                <h1>{ t('about.h1_1') }</h1>
                <h2>{ t('about.h2_1') }</h2>
                <p> { t('about.p_1') }<strong> { t('about.strong') } </strong>{ t('about.p_1_part2') }</p>
                <h2>{ t('about.h2_2') }</h2>
                <p>{ t('about.p_2') }</p>
                <p>{ t('about.p_3') }</p>
                <h2>{ t('about.h2_3') }</h2>
                <p> { t('about.p_4') }</p>
                <p><strong>{ t('about.p_5') }</strong></p>
                <a href= {t('pdf') ? CVenglish : CVfrench} download>
                    <button>{ t('about.btn') }</button></a>
                <h3>{ t('about.h3_1') }</h3>
                <h3>{ t('about.h3_2') }</h3>
            </div>
        </div>
    )
}

export default About
